const Countdown = require('./countdown.js');
const STATUS_CONTAINER = '#auction-status-container';
const DIALOG = '#auction-dialog';

function updateAuctionSidebarModule(html) {
  var auctionStatus = $(STATUS_CONTAINER),
    auctionStatusParent = auctionStatus.parent();
  auctionStatus.html(html);
  auctionStatusParent.highlight();
}

function displayOutbidStatus(outbidHtml) {
  updateAuctionStatus(function (dialog) {
    dialog
      .removeClass('alert alert-success')
      .html(outbidHtml)
      .height('auto');
  });
}

function displayHighBidder(successHtml) {
  var auctionStatus = $(STATUS_CONTAINER);

  updateAuctionStatus(function () {
    $.fancybox.close();
    updateAuctionSidebarModule(successHtml);
  });
}

function updateAuctionStatus(callback) {
  var dialog = $(DIALOG).parent();
  Reverb.UI.spinWithMessage(dialog, 'Placing bid...');
  setTimeout(
    function () {
      callback(dialog);
      Countdown.init();
    }, 500);
}

module.exports = {
  updateAuctionSidebarModule,
  displayOutbidStatus,
  displayHighBidder,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_response_handler.js